import { Price, Discount } from 'shared-types/Common';
import React, { FC } from 'react';
import { DiscountPrice } from '@common/components/Price';
import { ParentComponent, PriceBubble } from './TimeSlotOptionHOC.styles';
import { SingleValueProps } from 'react-select';

type TimeSlotOptionProps = {
  parentType?: string;
  data: {
    label: string;
    price: Price;
    discount: Discount;
    value?: string;
  };
  isFocused: boolean;
  isSelected: boolean;
  innerProps: {};
} & SingleValueProps;

export const TimeSlotOptionHOC: FC<TimeSlotOptionProps> = (props) => {
  const {
    parentType = 'Option',
    data: { price, label, discount },
    innerProps,
    isSelected,
  } = props;

  const isOption = parentType === 'Option';

  return (
    <ParentComponent
      {...(innerProps as {})}
      style={{ ...(props.getStyles('singleValue', props) as React.CSSProperties) }}
      isSelected={isSelected}
      isOption={isOption}
    >
      <span>{label}</span>
      <PriceBubble>{price && <DiscountPrice price={price} discount={discount} />}</PriceBubble>
    </ParentComponent>
  );
};
